<template>
  <div class="screen-booking">
    <div class="popup-aside-plain">
      <div class="popup-takeResa">
        <div style="text-align:center">{{ getAllInfos.restoName }}</div>
        <div style="font-weight:100; font-size:14px">
          <div style="text-align:center">{{ getAllInfos.restoAdresse }}</div>
          <div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
        </div>
      </div>
      <div class="success-container" v-loading="loading">
        <el-row :class="'black-inputs'">
          <el-col :span="18" :offset="3">
            <br>
            <div>
              <p v-if="getAllInfos.resaConfirmMessage">
                {{ getAllInfos.resaConfirmMessage }}
              </p>
              <p v-else>
                Bravo ! <br />Votre réservation est acceptée par le restaurateur.
              </p>
            </div>
            <br>
            <div v-if="currentResa">
              Nous vous attendons donc le {{ currentResa.date.labelDay }} {{ currentResa.date.day }}
              {{ currentResa.date.labelMonth }} {{ currentResa.date.year }} à {{ currentResa.hour }} pour
              {{ currentResa.couverts }} personne(s)
              et un prepaiement de {{ currentResa.total }} € a été fait.
            </div>
            <br>
            <div v-if="getAllInfos.resaAutoAcceptPrepaiementMessage"
              v-html="renderMarkdown(getAllInfos.resaAutoAcceptPrepaiementMessage)">
            </div>
            <br>
            <div>Merci pour votre réservation. </div>
            <br>
            <div></div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// ------------------------------------------------------------------------------------ Imports
import { mapActions, mapGetters } from 'vuex';
import 'whatwg-fetch';
import { ERequestType, fetchGetHelper } from '../tools/fetch';
import { renderMarkdown } from '../tools/markdownHelper';

export default {
  name: 'SuccessPAuto',
  // -------------------------------------------------------------------------------- Datas
  data() {
    return {
      currentResa: undefined,
      currentClient: undefined,
      loading: true,
      type: null,
      value: 0,
      inValidation: false
    }
  },
  computed: {
    // ------------------------------------------------------------------------------ Getters
    ...mapGetters({
      getAllInfos: 'infos/getAllInfos'
    })
  },
  methods: {
    // ----------------------------------------------------------------------------- Methods and Actions
    renderMarkdown,
    ...mapActions({
      checkClientByCidExisting: 'newClients/checkClientByCidExisting',
      loadInfos: 'infos/loadInfos'
    }),
    validResa: function () {
      if (!this.inValidation) {
        this.inValidation = true
        // get cash resa by id
        fetchGetHelper(ERequestType.CASHRESAS.GET_BY_ID, `crid=${this.$router.currentRoute.params.crid}`).then((res) => {
          this.type = res.data.type
          this.value = Math.round((parseFloat(res.data.amount) * parseInt(res.data.couverts)) * 100) / 100
          this.currentResa = res.data

          this.loading = false
        })
      }
    }
  },
  watch: {
    'getAllInfos': function (val, oldVal) {
      if (val.restoName) {
        this.validResa()
      }
    }
  },
  // ------------------------------------------------------------------------------------ Created
  created: function () {
    this.loadInfos().then(res => {
      console.log(res)
    })
    if (this.getAllInfos.restoName) {
      this.validResa()
    }
    // remove version
    if (this.$parent.$refs.version !== undefined) this.$parent.$refs.version.remove()
  }
}
</script>

<style lang="scss">
@use "../styles/vars";
@use "../styles/mixins";

@use "../styles/components/elements/popup";
@use "../styles/components/elements/blackInputs";
@use "../styles/components/elements/buttons";
@use "../styles/components/elements/nav";
@use "../styles/components/elements/notif";
@use "../styles/components/elements/selector";
@use "../styles/components/layout/screens";
@use "../styles/components/layout/calendar";

a {
  color: var(--color_blue_azure);
}

.success {
  &-content {
    text-align: center;
    font-weight: 100;
    margin-top: 1rem;
  }

  &-container {
    padding-bottom: 1rem;
  }

  &-btns {
    margin-top: 2rem;
  }

  &-infos {
    margin-top: 1rem;
    font-weight: bold;
  }
}
</style>
